import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-slate-900 text-slate-400 py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-orange-500 rounded-sm flex items-center justify-center">
                <span className="text-white font-bold text-sm">A</span>
              </div>
              <span className="font-semibold text-white text-lg tracking-tight" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
                AUTOMAT.IO
              </span>
            </div>
            <p className="text-sm leading-relaxed max-w-md">
              {t('hero_subtitle')}
            </p>
            <p className="text-xs mt-4 text-slate-500">
              Delta Impianti Polska<br />
              ul. św. Antoniego Padewskiego 5/7, 90-038 Lodz<br />
              NIP: 7272835952
            </p>
          </div>

          {/* Specializations */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">
              {t('pro_specializations')}
            </h4>
            <ul className="space-y-2 text-sm">
              <li>{t('spec_mechatronics')}</li>
              <li>{t('spec_mechanical')}</li>
              <li>{t('spec_electrical')}</li>
              <li>{t('spec_software')}</li>
            </ul>
          </div>

          {/* Legal & Regions */}
          <div>
            <h4 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">
              Informazioni Legali
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/terms" className="hover:text-white transition-colors">
                  Termini di Servizio
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <a href="mailto:deltaimpianti.de@gmail.com" className="hover:text-white transition-colors">
                  Contattaci
                </a>
              </li>
            </ul>
            
            <h4 className="text-white font-semibold mb-4 mt-6 text-sm uppercase tracking-wider">
              {t('pro_regions')}
            </h4>
            <ul className="space-y-2 text-sm">
              <li>{t('region_europe')}</li>
              <li>{t('region_asia')}</li>
              <li>{t('region_america')}</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs">
            © {new Date().getFullYear()} AUTOMAT.IO. {t('footer_rights')}.
          </p>
          <div className="flex items-center gap-6 text-xs">
            <Link to="/terms" className="hover:text-white transition-colors">
              Termini
            </Link>
            <Link to="/privacy" className="hover:text-white transition-colors">
              Privacy
            </Link>
            <span className="font-mono text-slate-500">v1.0.0</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
